import { render, staticRenderFns } from "./MajorBodyPartsList.vue?vue&type=template&id=4d324f6e"
import script from "./MajorBodyPartsList.vue?vue&type=script&lang=js"
export * from "./MajorBodyPartsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports